import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cime-bg p-4 text-center">
      <p
        className="text-7xl font-bold text-cime-primary mb-4"
        style={{ fontFamily: 'var(--cime-font-heading)' }}
      >
        404
      </p>
      <h1
        className="text-2xl font-bold text-neutral-900 mb-2"
        style={{ fontFamily: 'var(--cime-font-heading)' }}
      >
        Page introuvable
      </h1>
      <p className="text-sm text-neutral-500 mb-8 max-w-sm">
        La page que vous cherchez n&apos;existe pas ou a été déplacée.
      </p>
      <Button
        variant="primary"
        onClick={() => navigate('/dashboard', { replace: true })}
      >
        Retour au tableau de bord
      </Button>
    </div>
  );
}
